import { useEffect, useState } from 'react';
import { logWarn } from '../lib/log';

const MOBILE_QUERY = '(max-width: 768px), (pointer: coarse)';
const MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    mq.addEventListener('change', onChange);
    setMatches(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);
  return matches;
};

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);
export const usePrefersReducedMotion = () => useMediaQuery(MOTION_QUERY);

let webglSupport = null;
export const hasWebGL = () => {
  if (webglSupport !== null) return webglSupport;
  try {
    const c = document.createElement('canvas');
    const gl = c.getContext('webgl2') || c.getContext('webgl');
    webglSupport = !!gl;
    gl?.getExtension('WEBGL_lose_context')?.loseContext();
  } catch (error) {
    logWarn('WebGL probe failed:', error);
    webglSupport = false;
  }
  return webglSupport;
};
